/*@flow*/
import refinement from './refinement';
import isString from './isString';
import type { ValidationTypeT, TypeT } from './types';

export default function mysubtype(
  type: TypeT<*>,
  getErrMsg: any => string | boolean | null,
  name?: string
): ValidationTypeT {
  const validator = v => !isString(getErrMsg(v));
  const Subtype: any = refinement(type, validator, name);
  Subtype.getValidationErrorMessage = getErrMsg;
  return Subtype;
}
